export default {
  hitos: {
    group1: "Approval",
    group2: "Reimbursement",
    group3: "Marketing status",
    group4: "Homogeneous groups & reference prices",
    group5: "Reimbursement & dispensing conditions",
    group6: "Prices",
    group7: "Safety",
    group8: "Registration & technical data",
    group9: "Protection & exclusivity",
    group10: "Hospital access",
    group11: "Cross-cutting regulation",
    // SHORT labels for table chips
    groupShort1: "Approval",
    groupShort2: "Reimbursement",
    groupShort3: "Marketing",
    groupShort4: "Homog. groups / RP",
    groupShort5: "Reimb. conditions",
    groupShort6: "Prices",
    groupShort7: "Safety",
    groupShort8: "Registration",
    groupShort9: "Protection",
    groupShort10: "Hospital access",
    groupShort11: "Regulation",
    group: "Milestone group",
    hito: "Milestone",
    severity: "Severity",
    allGroups: "All groups",
    allHitos: "All milestones",
    allSeverities: "Any severity",
    colGroup: "Group",
    colHito: "Milestone",
    colSeverity: "Severity",
    sevA: "A · action with deadline",
    sevD: "D · decision required",
    sevI: "I · informational",
    sevAShort: "Action",
    sevDShort: "Decision",
    sevIShort: "Info",
    // Direction (R-19): favourable / adverse for the viewer, by milestone × ownership
    sentido_favorable: "Direction: favourable for you",
    sentido_adverso: "Direction: adverse for you",
    sentido_neutro: "Direction: neutral",
    noHito: "Unclassified",
    // Catalogue 3.9 (28 Sep 2026)
    structurePdf: "Milestone structure (PDF)",
    structurePdfFull: "See the full milestone structure (PDF)",
    sheetTitle: "Milestone sheet",
    sheetClose: "Close",
    sheetDescription: "What it is",
    sheetCatalogSources: "Catalogue sources",
    sheetMonitoredSince: "Monitored since",
    sheetHelixSources: "HelixScan sources",
    sheetSince: "since {date}",
    critOn: "Critical alert",
    critOff: "Not critical",
    critAria: "Critical alert: {hito}",
    critDefaultOn: "Default: critical",
    critDefaultOff: "Default: not critical",
    sheetCritical: "Critical alert by default",
    sheetCriticalOwn: "your product: {v}",
    sheetCriticalComp: "competitors: {v}",
    yes: "yes",
    no: "no",
    sheetFrequency: "Frequency",
    sheetWindow: "Window",
    sheetHistoryNote: "Anything published before HelixScan monitored the source creates no events or alerts: it is history and appears on each product's page.",
    sheetOpen: "Open the milestone sheet",
    monitoringSince: "HelixScan monitors events since {date}, when its first sources started; each source has its own date (see each milestone's sheet and Sources). Anything earlier is history: see each product's page.",
    firstCompetitor: "First competitor",
    firstCompetitorHint: "The first competitor to enter a homogeneous group where only your portfolio was present",
    abovePM: "Above the lowest price",
    abovePMHint: "This CN's retail price is now above the group's new lowest price: it loses substitution",
    historico: "Before monitoring",
    historicoHint: "Happened before HelixScan started monitoring the source: stored as history, not as an event",
    inactivo: "inactive in this edition",
    sinCobertura: "not covered yet",
    tabSeverity: "Severity",
    tabTexts: "Alert texts",
    txtIntro: "This is the “Why it matters” line in each alert email, depending on whether the product is yours or a competitor's. They start with the milestone catalogue texts; what you change here applies to your whole organisation. Leave it empty to go back to the default text.",
    txtLanguage: "Text language:",
    txtColPropio: "If it is your product",
    txtColCompetencia: "If it is a competitor's or in a watched group",
    txtSave: "Save",
    txtCancel: "Cancel",
    txtCustom: "Your organisation's text",
    txtRestore: "Back to the default text",
    sevPageTitle: "Severity by milestone",
    sevPageIntro: "Severity is the urgency to act, by milestone and by the product's relation to your portfolio. Defaults come from the milestone catalogue; your changes apply to your whole organisation and take precedence. The «Critical alert» mark is separate from the level: those events are emailed highlighted (“[CRITICAL]” in the subject) as soon as they are detected to anyone with critical alerts switched on.",
    sevColPropio: "If it is yours",
    sevColCompetencia: "If it is a competitor's or a group without your products",
    sevDefault: "Default: {sev}",
    sevRestoreAll: "Restore all ({n} changes)",
    sevRestoreAllTitle: "Go back to the default severity and critical alerts?",
    sevRestoreAllMsg: "Your organisation's {n} changes are undone and the milestone catalogue values come back.",
    txtRestoreAll: "Restore all ({n} texts)",
    txtRestoreAllTitle: "Go back to the default texts?",
    txtRestoreAllMsg: "Your organisation's {n} custom texts (Spanish and English) are deleted and the catalogue texts come back.",
    restoreConfirm: "Restore",
    sevRestore: "Restore default",
    sevDesenlaces: "By outcome or section",
    sevNa: "Does not fire",
    sevReadOnly: "Only your organisation's administrator can change it.",
    sevSaved: "Saved",
    sevSearch: "Search milestone…",
    sevOnlyCovered: "Only milestones HelixScan detects today",
  },
};
